import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff, Megaphone } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { dateParts } from "@/components/fo/Events";

export const EventsAdmin = () => {
  const [d, setD] = useState({ events: [] });
  const load = () => api.get("/admin/events").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const hide = async (e) => { await api.post(`/admin/events/${e.id}/hidden`, { hidden: !e.hidden }); toast.success(e.hidden ? "Event visible" : "Event hidden"); load(); };
  const announce = async () => {
    if (!window.confirm("Send the one-time 'Events are live' email to every registered artist?")) return;
    try { const r = await api.post("/admin/events/announce"); toast.success(`Announcement sent to ${r.data.count} artists`); load(); } catch (er) { toast.error(errMsg(er)); }
  };
  return (
    <div className="space-y-6" data-testid="admin-events">
      <div className="panel flex flex-wrap items-center justify-between gap-4 p-5">
        <div><div className="label-mono">One-time announcement</div>
          <p className="mt-1 text-sm text-slate-400">{d.announced_at ? `Sent on ${fmtDate(d.announced_at)} to ${d.announced_count} artists.` : "Tell every registered artist that Events are live (paid plans: 'add yours', Free: 'upgrade')."}</p></div>
        <button className="btn-hot !px-4 !py-2 text-xs" disabled={!!d.announced_at} onClick={announce} data-testid="events-announce"><Megaphone className="h-4 w-4" />{d.announced_at ? "Already sent" : "Send announcement"}</button>
      </div>
      <div className="space-y-2">
        {d.events.map((e) => {
          const p = dateParts(e.date);
          return (
            <div key={e.id} className={`panel flex flex-wrap items-center gap-4 p-4 ${e.hidden || e.past ? "opacity-60" : ""}`} data-testid={`admin-event-${e.id}`}>
              <div className="w-14 text-center"><div className="font-display text-2xl font-black leading-none">{p.day}</div><div className="font-mono text-[10px] text-slate-500">{p.month}</div></div>
              <div className="min-w-0 flex-1">
                <div className="font-display font-bold">{e.title}</div>
                <div className="font-mono text-xs uppercase text-slate-500">{e.artist_name} · {e.venue} · {e.city}{e.time && ` · ${e.time}`}{!e.artist_paid && " · free plan (not public)"}{e.past && " · past"}</div>
              </div>
              <button className="btn-ghost !px-3 !py-1.5 text-xs" onClick={() => hide(e)} data-testid={`admin-event-hide-${e.id}`}>{e.hidden ? <><Eye className="h-3.5 w-3.5" />Show</> : <><EyeOff className="h-3.5 w-3.5" />Hide</>}</button>
            </div>
          );
        })}
        {!d.events.length && <p className="text-sm text-slate-500">No events yet.</p>}
      </div>
    </div>
  );
};
